import { createTheme } from '@mui/material'

export const defaultTheme = createTheme()
